// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
interface GroupBoxProps extends OptionalHtmlProps {
    title: string;
    titleClass?: string;
}

function getClassName(className: string) {
    var classNames = 'group-box-control ctnt-main';
    if (className !== undefined && className.length > 0) {
        classNames += ' ' + className;
    }
    return classNames
}

const GroupBox = (props: GroupBoxProps) => (
    <fieldset style={props.styles} className={getClassName(props.class)}>
        <legend className={props.titleClass}>{props.title}</legend>
        {props.children}
    </fieldset>
);

export default GroupBox;